import { useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import TitleSection from "@/components/titleSection";
import BlogItemTwo from "@/components/blog/blogItemTwo";
import { SlickArrowLeft, SlickArrowRight } from "@/components/carouselArrow";
import { productSlug } from "@/lib/product";

const DEFAULT_RESPONSIVE = [
  { breakpoint: 1199, settings: { slidesToShow: 2, slidesToScroll: 1 } },
  { breakpoint: 575, settings: { slidesToShow: 1, slidesToScroll: 1 } },
];

// react-slick marks every off-screen slide with aria-hidden="true" but
// does not propagate `inert`, so any focusable <a>/<button> inside the
// slide stays in the tab order. Lighthouse audits flag the focused
// descendents as an a11y violation. We mirror aria-hidden → inert on
// every slide so off-screen cards are skipped by keyboard tabbing
// without breaking react-slick's own visibility model.
const syncSlideInert = (root) => {
  if (!root) return;
  const slides = root.querySelectorAll(".slick-slide");
  slides.forEach((slide) => {
    const hidden = slide.getAttribute("aria-hidden") === "true";
    if (hidden) {
      slide.setAttribute("inert", "");
      slide.setAttribute("aria-hidden", "true");
    } else {
      slide.removeAttribute("inert");
    }
  });
};

const LatestBlogFeeds = ({
  sectionSpace = "pt-115 pb-90",
  bgImage,
  subTitle = "News & Blogs",
  title = "Leatest News Feeds",
  data = [],
  baseUrl = "blog",
  slidesToShow = 3,
  slidesToScroll = 1,
  responsive = DEFAULT_RESPONSIVE,
  showArrows = true,
  sliderClassName = "ltn__blog-slider-one-active slick-arrow-1 ltn__blog-item-3-normal",
}) => {
  const sliderWrapRef = useRef(null);

  const settings = {
    dots: false,
    // `infinite: false` so react-slick doesn't clone the slides for the
    // carousel loop. Clones were duplicating blog card H3 headings in
    // the DOM (3 posts × 2 = 6 H3s instead of 3). With finite scroll
    // and only 3 items the slider still looks identical to visitors.
    infinite: false,
    speed: 500,
    slidesToShow,
    slidesToScroll,
    prevArrow: showArrows ? <SlickArrowLeft /> : undefined,
    nextArrow: showArrows ? <SlickArrowRight /> : undefined,
    responsive,
    afterChange: () => syncSlideInert(sliderWrapRef.current),
  };

  useEffect(() => {
    syncSlideInert(sliderWrapRef.current);
    const id = window.setInterval(
      () => syncSlideInert(sliderWrapRef.current),
      750
    );
    return () => window.clearInterval(id);
  }, []);

  const wrapperStyle = bgImage
    ? { backgroundImage: `url("../img/bg/${bgImage}")` }
    : undefined;

  const wrapperClass = bgImage
    ? `ltn__blog-area bg-image-top ${sectionSpace}`
    : `ltn__blog-area ${sectionSpace}`;

  return (
    <div className={wrapperClass} style={wrapperStyle}>
      <Container>
        <Row>
          <Col lg={12}>
            <TitleSection
              sectionClasses="text-center"
              headingClasses="section-subtitle-2"
              titleSectionData={{ subTitle, title }}
            />
          </Col>
        </Row>
        <div ref={sliderWrapRef}>
          <Slider {...settings} className={sliderClassName}>
            {data.map((item, key) => {
              const slug = productSlug(item.title);
              return (
                <div key={key} className="blog-card-slide">
                  <BlogItemTwo blogData={item} slug={slug} baseUrl={baseUrl} />
                </div>
              );
            })}
          </Slider>
        </div>
      </Container>
    </div>
  );
};

export default LatestBlogFeeds;
